import { render } from "./NetflixIcon.vue?vue&type=template&id=42bdd12a&scoped=true"
import script from "./NetflixIcon.vue?vue&type=script&lang=js"
export * from "./NetflixIcon.vue?vue&type=script&lang=js"

import "./NetflixIcon.vue?vue&type=style&index=0&id=42bdd12a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bdd12a"]])

export default __exports__